import BaseShippingController from "./base_shipping_controller";

const TARGET_ROUNDUP_SWITCH = 'roundupSwitch';
const TARGET_ROUNDUP_VALUE_SUBTOTAL = 'roundupValueSubtotal';
const TARGET_ROUNDUP_BUYUP_COUNT = 'roundupBuyupCount';
const TARGET_ROUNDUP_LINE_ITEM_TOTAL = 'roundupLineItemTotal';
const TARGET_SHIPPABLE_VALUE_SUBTOTAL = 'shippablevalueSubtotal';
const TARGET_FREEE_SHIPPING_VALUE = 'freeShippingValue';
const TARGET_PROGRESS_TEXT = 'progressText';
const TARGET_PROGRESS_STYLE = 'progressStyle';
const TARGET_CONTINUE_BUTTON  = 'continueButton';

export default class extends BaseShippingController {
  static targets = [
    TARGET_ROUNDUP_SWITCH,
    TARGET_ROUNDUP_VALUE_SUBTOTAL,
    TARGET_ROUNDUP_BUYUP_COUNT,
    TARGET_ROUNDUP_LINE_ITEM_TOTAL,
    TARGET_SHIPPABLE_VALUE_SUBTOTAL,
    TARGET_CONTINUE_BUTTON
  ]

  static values = {
    url: String
  }

  handleRoundupSwitchChange(event, urlValue = this.urlValue) {
    const allroundup = event?.target?.checked;
    const updatedBasketState = this.updatedBasketState(allroundup);
    this.updateForm(updatedBasketState);
    let allrounduphash = {};
    if (allroundup != null) {
      allrounduphash = { allRoundup : allroundup };
    }
    const fetchUrl = this.buildFetchUrl(urlValue, {
      updatedBasketState: JSON.stringify(updatedBasketState),
      ...allrounduphash
    });

    this.fetchJson(fetchUrl).then(data => {
      if (!data) return;
      this.updateLineItems(data);
      const subtotalTarget = allroundup != null
        ? `[data-roundup-target="${TARGET_ROUNDUP_VALUE_SUBTOTAL}"]`
        : this.roundupValueSubtotalTarget;
        
      $(subtotalTarget).text(data.subtotal.value);
      this.updateProgessBar(data);
    });
  }


  updateProgessBar(data){
    $(`[data-roundup-target="${TARGET_SHIPPABLE_VALUE_SUBTOTAL}"]`).text(data.totalShippableValue);
    const totalValue = parseFloat(data.totalShippableValue.replace(/[^0-9.-]+/g, ''));
    const freeValueText =  $(`[data-roundup-target="${TARGET_FREEE_SHIPPING_VALUE}"]`).text()
    const freeValue = parseFloat(freeValueText.replace(/[^0-9.]/g, '')) || 0;
    const progressTextElement = $(`[data-roundup-target="${TARGET_PROGRESS_TEXT}"]`);
    const progressStyleElement = $(`[data-roundup-target="${TARGET_PROGRESS_STYLE}"]`);
    const continuebtn = $(`[data-roundup-target="${TARGET_CONTINUE_BUTTON}"]`);

    if (totalValue >= freeValue) {
      progressTextElement.html(`Congratulations you qualify for <strong class='font-semibold'>Free Shipping!</strong>`);
      progressStyleElement.css('grid-template-columns', '100fr 0fr');
    } else {
      const remainingValue = freeValue - totalValue
      progressTextElement.html(`You're only <strong class='font-semibold'>$${remainingValue.toFixed(2)}</strong> away from <strong class='font-semibold'>Free Shipping!</strong>`);
      progressStyleElement.css('grid-template-columns', `${totalValue}fr ${remainingValue}fr`);
    }

    if (totalValue == 0.0) {
      continuebtn.prop("disabled",true);
      continuebtn.removeClass('cursor-pointer bg-yellow-400 hover:bg-yellow-500').addClass('text-gray-400 bg-gray-200')
    } else {
      continuebtn.prop("disabled",false);
      continuebtn.addClass('cursor-pointer bg-yellow-400 hover:bg-yellow-500').removeClass('text-gray-400 bg-gray-200')
    } 
  }

  roundupSwitchChanged() {
    this.handleRoundupSwitchChange();
  }

  allroundupSwitchChanged(event) {
    const urlValue = event.target.dataset.urlValue;
    this.handleRoundupSwitchChange(event, urlValue);
  }

  updatedBasketState(allroundup = null) {
    return $(this.roundupItemSelector()).map((_, el) => {
      const $el = $(el);
      const crateItemId = $el.data('crate-item-id');
      if(allroundup != null) {
        $el.find('input[type="checkbox"]').prop('checked', allroundup)
      }
      const roundupSwitchVal = allroundup != null ? allroundup : $el.find('input[type="checkbox"]:visible').is(':checked');
      const hiddenSwitchValue =  $el.find('input[type="checkbox"]:hidden').is(':checked');
      if (allroundup == null && roundupSwitchVal != hiddenSwitchValue) {
        $el.find('input[type="checkbox"]:hidden').prop('checked', roundupSwitchVal)
      }
      return { crateItemId, roundupSwitchVal };
    }).get();
  }

  updateForm(updatedBasketState) {
    updatedBasketState.forEach(basket => {
      const $el = $(`.roundup-lineitem-field[data-crate-item-id="${basket.crateItemId}"]`);
      $el.val(`${basket.roundupSwitchVal}`);
    });
  }

  updateLineItems(data) {
    data.lineItems.forEach(li => this.updateLineItem(li));
  }

  updateLineItem(li) {
    const $row = $(this.roundupItemSelector(li.crateItemId));
    const $lineItemTotal = $row.find('[data-roundup-target="roundupLineItemTotal"]');
    $lineItemTotal.text(`${li.value}`);
  }

  roundupItemSelector(id = null) {
    return id
      ? `div[data-crate-item-id="${id}"]`
      : 'div[data-crate-item-id]';
  }
}
